import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/site/Layout";
import ScrollToTop from "@/components/site/ScrollToTop";
import Home from "@/pages/Home";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Comprendre from "@/pages/Comprendre";
import Avis from "@/pages/Avis";
import ConsultationDetail from "@/pages/ConsultationDetail";
import Carte from "@/pages/Carte";
import Actions from "@/pages/Actions";
import ActionDetail from "@/pages/ActionDetail";
import Droits from "@/pages/Droits";
import Temoignages from "@/pages/Temoignages";
import EspaceCEF from "@/pages/EspaceCEF";
import Rejoindre from "@/pages/Rejoindre";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Profil from "@/pages/Profil";
import Agir from "@/pages/Agir";
import AuthCallback from "@/pages/AuthCallback";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PedagoDetail from "@/pages/PedagoDetail";
import { isAuthed } from "@/lib/api";
import { AuthProvider } from "@/lib/auth-context";

function AdminProtected({ children }) {
  return isAuthed() ? children : <Navigate to="/admin/login" replace />;
}

// Synchronously handle Google session_id from URL fragment
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminProtected><AdminDashboard /></AdminProtected>} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/*" element={
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/actualites" element={<News />} />
            <Route path="/actualites/:slug" element={<NewsDetail />} />
            <Route path="/comprendre" element={<Comprendre />} />
            <Route path="/comprendre/:id" element={<PedagoDetail />} />
            <Route path="/agir" element={<Agir />} />
            <Route path="/donner-mon-avis" element={<Avis />} />
            <Route path="/donner-mon-avis/:slug" element={<ConsultationDetail />} />
            <Route path="/carte" element={<Carte />} />
            <Route path="/actions" element={<Actions />} />
            <Route path="/actions/:id" element={<ActionDetail />} />
            <Route path="/droits" element={<Droits />} />
            <Route path="/temoignages" element={<Temoignages />} />
            <Route path="/cef" element={<EspaceCEF />} />
            <Route path="/rejoindre" element={<Rejoindre />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/profil" element={<Profil />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <Toaster position="top-center" richColors closeButton />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
